import { createTheme } from '@mui/material/styles';

// "Circadian Calm" palette — app-wide MUI theme.
// Replaces MUI's defaults (blue primary, PURPLE secondary #9c27b0) so every
// MUI component — menus, buttons, loading spinners, alerts — uses the brand palette.
const theme = createTheme({
    palette: {
        primary: { main: '#1F6DA2' },   // brand
        secondary: { main: '#5B6B9E' },  // sleep indigo (was MUI purple)
        error: { main: '#C85C6E' },      // cardio rose
        warning: { main: '#D08A3E' },    // stress ochre
        success: { main: '#2A9D8F' },    // recovery teal
        info: { main: '#1F6DA2' },
    },
});

export default theme;
